import type { MeritFilter } from "./types";

type HasState = (states: readonly string[]) => MeritFilter;

export const hasState: HasState = states => merit => states.includes(merit.state?.name ?? "");
